import "./index.css";
import Sidebar from "./components/Sidebar/Sidebar";
import MainScreen from "./pages/MainScreen/MainScreen";
import Breadcrumb from "./components/Breadcrumb/BreadCrumb";

function App() {
  return (
    <div className="main-screen">
      <Sidebar />
      <Breadcrumb />
      <MainScreen />
    </div>
  );
}

export default App;
